import { render, staticRenderFns } from "./RsaConfigurazioneAssociaUtenteLaboratorioModalComponent.vue?vue&type=template&id=33d35cb2"
import script from "./RsaConfigurazioneAssociaUtenteLaboratorioModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAssociaUtenteLaboratorioModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports